import { useSelector } from "react-redux";

import Breadcrumbs from "@/common/Breadcrumbs";

const BreadcrumbsComp = ({breadcrumbList}) => {
  return <Breadcrumbs breadcrumbList={breadcrumbList} />;
};

export default BreadcrumbsComp;
